import { PageUrlSegment } from '../types/bnz-page-url-segment.type';

export const getMainUrlSegment = (url: string): PageUrlSegment => {
  const numberOfSlashes: number = (url.match(/\//g) || []).length;
  let mainUrlSegment = '';
  if (url !== '/') {
    if (url.includes('redeem_cash/enrollment')) {
      return PageUrlSegment.REDEEMCASH_ENROLLMENT;
    }
    if (url.includes('transfer/checkout') && url.includes('membership')) {
      return PageUrlSegment.TRANSFER_ADD_MEMBERSHIP;
    }
    if (url.includes('transfer/checkout')) {
      return PageUrlSegment.TRANSFER_LANDING;
    }
    if (url.includes('redeem_cash/auto-redemption')) {
      return PageUrlSegment.REDEEMCASH_AR;
    }
    if (url.includes('offers/details')) {
      return PageUrlSegment.OFFERS_DETAILS;
    }
    if (url.includes('rewards_programs/link_flybuys_account')) {
      return PageUrlSegment.REWARDS_PROGRAMS;
    }

    if (
      numberOfSlashes === 3 ||
      (numberOfSlashes === 4 && url.includes('flybuys'))
    ) {
      mainUrlSegment = url.substring(0, url.lastIndexOf('/'));
    } else if (url.includes('?state')) {
      mainUrlSegment = '';
    } else if (url.includes('?')) {
      mainUrlSegment = url.substring(0, url.lastIndexOf('?'));
    } else {
      mainUrlSegment = url;
    }
  }

  return mainUrlSegment as PageUrlSegment;
};

export const getUrlParamId = (url: string, delimeter = '/'): string => {
  const parts: string[] = url.split(delimeter);
  return parts[parts.length - 1];
};
